import { useNavigate } from 'react-router-dom'
import { useWorkspace } from '../../../../../contexts/WorkspaceContext'
import { useAppSelector } from '../../../../../store/hooks'
import { selectProjectById } from '../../../../../store/projects/projectsSelectors'
import TaskModalAssigned from './components/TaskModalAssigned/TaskModalAssigned'
import TaskModalStatus from './components/TaskModalStatus/TaskModalStatus'
import TaskModalLabels from './components/TaskModalLabels/TaskModalLabels'
import ButtonRound from '@/components/ui/ButtonRound/ButtonRound'
import ProjectIcon from '@/assets/icons/icon-project.svg?react'
import css from './TaskModalProperties.module.css'

const useWorkspaceSafe = () => {
    try {
        return useWorkspace()
    } catch {
        return null
    }
}

interface TaskModalPropertiesProps {
    taskId: string
    projectId: string
    assigneeId: string | null
    statusId: string
    labelIds: string[] | null | undefined
    onUpdate: (updates: { assigneeId?: string | null; statusId?: string; isCompleted?: boolean; labels?: string[] }) => Promise<void>
}

const TaskModalProperties = ({
    taskId,
    projectId,
    assigneeId,
    statusId,
    labelIds,
    onUpdate,
}: TaskModalPropertiesProps) => {
    const navigate = useNavigate()
    const workspaceContext = useWorkspaceSafe()
    const project = useAppSelector(state => selectProjectById(state, projectId))
    const workspace = workspaceContext?.workspace

    const handleProjectClick = () => {
        if (workspace && project) {
            navigate(`/${workspace.workspaceUrlId}/projects/${project.id}`)
        }
    }

    const handleMemberChange = async (memberId: string | null) => {
        await onUpdate({ assigneeId: memberId })
    }

    const handleStatusChange = async (newStatusId: string) => {
        await onUpdate({ statusId: newStatusId })
    }

    const handleLabelsChange = async (labels: string[]) => {
        await onUpdate({ labels })
    }

    return (
        <div className={css.properties}>
            <div className={css.property}>
                <ButtonRound icon={<ProjectIcon />} onClick={handleProjectClick}>{project?.name || 'Untitled'}</ButtonRound>
                <TaskModalAssigned
                    memberId={assigneeId}
                    onMemberSelect={handleMemberChange}
                />
            </div>
            <div className={css.property_status}>
                <TaskModalLabels
                    taskId={taskId}
                    labelIds={labelIds}
                    onChange={handleLabelsChange}
                />
                <TaskModalStatus
                    statusId={statusId}
                    onStatusChange={handleStatusChange}
                />
            </div>
        </div>
    )
}

export default TaskModalProperties
